var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18NLink, Translate } from "../I18N";
import { createSelector } from 'reselect';
import { libraryViewInfo } from "./libraryViewInfo";

const getLibraryURL = (libraryView) =>
libraryViewInfo[libraryView] ? `/${libraryViewInfo[libraryView].url}` : '/library';

class Footer extends Component {
  render() {
    return (/*#__PURE__*/
      _jsx("footer", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: "logobox" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "logobox-left" }, void 0, /*#__PURE__*/
      _jsx("a", { href: "http://tomlantosinstitute.hu/en/", target: "_blank", className: "footer-logo", rel: "noreferrer" }, void 0, /*#__PURE__*/
      _jsx("img", {
        src: "/public/tom_lantos/tli_en.svg",
        title: "Tom Lantos Institute",
        alt: "Tom Lantos Institute" }
      )
      )
      ), /*#__PURE__*/

      _jsx("div", { className: "logobox-middle" }, void 0, '\u00A0'), /*#__PURE__*/

      _jsx("div", { className: "logobox-right" }, void 0, /*#__PURE__*/
      _jsx("a", { href: "https://hrc.sas.ac.uk/", target: "_blank", className: "footer-logo", rel: "noreferrer" }, void 0, /*#__PURE__*/
      _jsx("img", {
        src: "/public/tom_lantos/londonilogo.png",
        title: "Human Rights Consortium",
        alt: "Human Rights Consortium" }
      )
      )
      )
      ), /*#__PURE__*/

      _jsx("div", { className: "logobox logobox-links" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "logobox-left" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, { to: "/page/impressum" }, void 0, /*#__PURE__*/
      _jsx(Translate, { context: "Page" }, void 0, "Impressum")
      )
      ), /*#__PURE__*/

      _jsx("div", { className: "logobox-middle" }, void 0, '\u00A0'), /*#__PURE__*/

      _jsx("div", { className: "logobox-right" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, { to: "/page/privacy-policy" }, void 0, /*#__PURE__*/
      _jsx(Translate, { context: "Page" }, void 0, "Privacy Policy")
      )
      )
      )
      ));

  }
}







Footer.defaultProps = {
  defaultLibraryView: 'cards'
};

const selectUser = createSelector(
  (s) => s.user,
  (u) => u.toJS()
);

export function mapStateToProps(state) {
  return {
    user: selectUser(state),
    siteName: state.settings.collection.get('site_name'),
    defaultLibraryView: state.settings.collection.get('defaultLibraryView')
  };
}

export default connect(mapStateToProps)(Footer);